import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PublishDate = makeShortcode("PublishDate");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Colin Reeves contributed to a an item on Uptown Radio in New York concerning a
new World Bank  initiative in Africa. The plan is to raise US$ 1 billion for
systematic mapping of the whole of Africa  to stimulate the resource exploration
sector. Many people probably find it difficult to imagine that  the geology and
resources of much of the continent is still largely unknown, even today. The
original news report came from `}<a parentName="p" {...{
        "href": "/reevesdotnl/"
      }}>{`Reuters`}</a>{`. `}</p>
    <p>{`Africa is, at the same time, both the central fragment and the weakest link in
the geology of  Gondwana when the maps of the other fragments of the former
supercontinent are put together.  In the past 40 years, in Colin's experience, a
sum of close to $1 billion has already been spent on  geophysical mapping
exercises in sub-Saharan Africa. While some countries, such as Botswna and
Namibia have exemplary records of publishing the results of these baseline
geoscience exercises,  many others have fallen into the misconception that such
data sets are some kind of national  'treasure map' that should be kept secret.
As a result, the data is inaccessible to the majority of  earth scientists who
could bring their intellect to bear on interpreting it and so fleshing out the
regional geology of Africa's extensive - but largely concealed - Precambrian
terranes. Such major  geological divisions of the Precambrian geology obviously
cross national frontiers within Africa just  as they also cross from Africa into
other Gondwana continents that were formerly part of the same  continuous
continental crust. International cooperation, with a maximum of input from the
resident  geologists of Africa, is therefore the logical way ahead. But many
political leaders in Africa fail to  endorse this belief. `}</p>
    <PublishDate mdxType="PublishDate" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      